import { useSetupDataQuery } from '@booking-portal/api/queries/use-setup-data-query';
import { useCurrentLocation } from '@booking-portal/composables/use-current-location';
import { useSentry } from '@booking-portal/composables/use-sentry';
import { useAppStore } from '@booking-portal/stores/app-store';
import { useTranslationUtils } from '@booking-portal/utils/translation-utils';
import { watchEffect } from 'vue';

export async function useSetupData() {
  const { addTranslations } = useTranslationUtils();
  const appStore = useAppStore();

  const { routeLocationId } = useCurrentLocation();

  const { data, error } = useSetupDataQuery(routeLocationId);

  watchEffect(() => {
    if (data.value) {
      appStore.setupData = data.value.data;

      if (data.value?.data?.translations) {
        addTranslations(data.value.data.translations);
      }
    } else if (error.value) {
      const sentry = useSentry();
      sentry.captureException(error.value);
    }
  });
}
